import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-print',
  templateUrl: './menu-print.component.html',
  styleUrls: ['./menu-print.component.css']
})
export class MenuPrintComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
